module.exports = __webpack_public_path__ + "img/img-12.311317e2.png";